import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { uploadQuote } from "../../actions/upload";
import Subjects from "../../data/subjects";

import Form from "../Forms/Quote/Quote";

import "./Pricing.css";

const Pricing = () => {
  const dispatch = useDispatch();
  const reloadQuote = useSelector((state) => state.upload);
  const history = useHistory();
  const price = Subjects.filter(
    (subject) => subject.subject === reloadQuote.subject
  )[0].value;
  const [showPrice, setShowPrice] = useState(false);
  const [addson, setAddson] = useState({
    notarization: 0,
    sworn: 0,
    certified: 0,
    apostilles: 0,
  });

  const apostillePrice = (apostilles) => {
    if (apostilles === 0) return 0;
    return apostilles + (reloadQuote?.files?.length - 1) * 80;
  };

  const handleCheck = (e) => {
    if (!e.target.checked) return setAddson({ ...addson, [e.target.name]: 0 });
    setAddson({ ...addson, [e.target.name]: Number(e.target.value) });
  };

  const handlePriceSelect = (price, category) => {
    dispatch(
      uploadQuote({
        price,
        category,
        addson: {
          notarization:
            addson.notarization *
            (reloadQuote.files ? reloadQuote.files.length : 0),
          sworn: addson.sworn,
          certified: addson.certified,
          apostilles: apostillePrice(addson.apostilles),
        },
      })
    );

    return history.push("/quote#user-info");
  };

  useMemo(() => {
    if (reloadQuote.addson) {
      setAddson({
        notarization: reloadQuote.addson.notarization > 0 ? 80 : 0,
        sworn: reloadQuote.addson.sworn > 0 ? 56 : 0,
        certified: reloadQuote.addson.certified > 0 ? 0 : 0,
        apostilles: reloadQuote.addson.apostilles > 0 ? 130 : 0,
      });
    }
  }, [reloadQuote]);

  const showPriceStyle = {
    height: window.innerWidth < 769 ? "auto" : "760px",
  };

  return (
    <div id="form" className="pricing container">
      <div className="pricing__top mb-40">
        <h2 className="text-center mt-40 mb-10 font-subhead">
          Translation at <span className="font-large pl-5">Your Doorstep</span>
        </h2>
        <p className="font-normal font-heavy text-center mx-auto">
          Our 50,000 plus vetted professional translators have been translating
          for over 10 years and we always bring smiles to the faces of our
          clients.
        </p>
      </div>
      <Form setShowPrice={setShowPrice} showPrice={showPrice} />
      <div
        className="pricing__ctn overflow-hidden"
        style={showPrice ? showPriceStyle : {}}
      >
        <div className="pricing__top">
          <h2 className="text-center my-40 font-subhead">
            Check out our{" "}
            <span className="font-large pl-5">Affordable Prices</span>
          </h2>
        </div>
        <div className="grid-3 text-center overflow-hidden">
          <div className="pricing__price">
            <div className="pricing__category lh-lg font-big font-bolder box-shadow-sm">
              GENERAL
            </div>
            <div className="pricing__category font-heavy font-big">
              General Content
            </div>
            <div className="price__cat__price py-40 font-large font-bolder border-top">
              $0.17 <span className="font-big">/ word</span>
            </div>
            <div className="price__cat__options d-flex flex-column justify-around align-center">
              <ul className="font-heavy list-none">
                <li className="lh-lg">Brand</li>
                <li className="lh-lg">Social Media</li>
                <li className="lh-lg">Emails</li>
                <li className="lh-lg">Native Translation (Non-Formal)</li>
                <li className="lh-lg">etc.</li>
              </ul>
              <button
                className="button bg-orange w-50"
                onClick={() => handlePriceSelect(0.17, "General")}
              >
                Order Now
              </button>
            </div>
          </div>
          <div className="pricing__price">
            <div className="pricing__category lh-lg font-big font-bolder box-shadow-sm">
              PROFESSIONAL
            </div>
            <div className="pricing__category font-heavy font-big">
              {reloadQuote.subject}
            </div>
            <div className="price__cat__price py-40 font-large font-bolder border-top">
              ${price.toFixed(2)} <span className="font-big">/ word</span>
            </div>
            <div className="price__cat__options d-flex flex-column justify-around align-center">
              <ul className="font-heavy list-none">
                <li className="lh-lg">Industry Expert</li>
                <li className="lh-lg">Industry Specific</li>
                <li className="lh-lg">Detailed</li>
                <li className="lh-lg">Versatile</li>
              </ul>
              <button
                className="button bg-orange w-50"
                onClick={() => handlePriceSelect(price, "Professional")}
              >
                Order Now
              </button>
            </div>
          </div>
          <div className="pricing__price">
            <div className="pricing__category lh-lg font-big font-bolder box-shadow-sm">
              CERTIFIED
            </div>
            <div className="pricing__category font-heavy font-big">
              {reloadQuote.subject}
            </div>
            <div className="price__cat__price py-20 font-large font-bolder border-top">
              ${price.toFixed(2)} <span className="font-big">/ word</span>
              <div className="font-bigger pt-5">
                plus $
                {(
                  apostillePrice(addson.apostilles) +
                  addson.sworn +
                  addson.certified +
                  addson.notarization *
                    (reloadQuote.files ? reloadQuote.files.length : 0)
                ).toFixed(2)}
              </div>
            </div>
            <div className="price__cat__options d-flex flex-column justify-around align-center">
              <ul className="font-heavy list-none">
                <li className="lh-lg d-flex flex-start py-10">
                  <label>
                    <input
                      type="checkbox"
                      name="certified"
                      value={0}
                      defaultChecked
                    />{" "}
                    <span>Certified Translation</span>
                  </label>
                </li>
                <li className="lh-lg d-flex flex-start py-10">
                  <label>
                    <input
                      type="checkbox"
                      name="apostilles"
                      value={130}
                      checked={addson.apostilles !== 0}
                      onChange={handleCheck}
                    />{" "}
                    <span>Apostilles</span>
                  </label>
                </li>
                <li className="lh-lg d-flex flex-start py-10">
                  <label>
                    <input
                      type="checkbox"
                      name="sworn"
                      value={56}
                      checked={addson.sworn !== 0}
                      onChange={handleCheck}
                    />{" "}
                    <span>Sworn Translation</span>
                  </label>
                </li>
                <li className="lh-lg d-flex flex-start py-10">
                  <label>
                    <input
                      type="checkbox"
                      name="notarization"
                      value={80}
                      checked={addson.notarization !== 0}
                      onChange={handleCheck}
                    />{" "}
                    <span>Notarization</span>
                  </label>
                </li>
              </ul>
              <button
                className="button bg-orange w-50"
                onClick={() => handlePriceSelect(price, "Certified")}
              >
                Order Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
